import React from 'react';

import { ConnectedSignup } from './signup.component';

const title = 'Signup';

function action() {
  return {
    chunks: ['signup'],
    title,
    component: <ConnectedSignup />,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/signup/signup.route.js